import { z } from 'zod';
import { instagramUsernameValidation } from '../../../commonValidation';

const stripHtmlTags = (value: string): string => value.replace(/<[^>]*>/g, '');

const createImgSchema = (message?: string) =>
  z
    .object(
      {
        image: z.string(),
        cdn01: z.string(),
      },
      { invalid_type_error: message, required_error: message },
    )
    .passthrough();

const MediaVideo = z
  .object({
    video: z.string(),
    cdn01: z.string(),
  })
  .passthrough();

export const profileSchema = z.object({
  firstName: z.string().trim().min(1, { message: 'Required' }),
  lastName: z.string().trim().min(1, { message: 'Required' }),

  customColorSchema: z.object({
    primaryColor: z.string().regex(/^[0-9A-Fa-f]{6}$/, 'Invalid hex color'),
  }),
  gender: z.union([z.literal('M'), z.literal('F')]).nullable(),

  profileInstagram: instagramUsernameValidation,
  profileTiktok: z
    .string()
    .refine((v) => !v.startsWith('@'), { message: 'Do not include @' })
    .nullable(),
  profileYoutubeChannel: z
    .string()
    .refine((v) => !v || v.startsWith('https://'), {
      message: 'Provide full link',
    })
    .nullable(),

  title: z.string().trim().min(1, { message: 'Required' }),
  messageProfile: z.string().max(800).transform(stripHtmlTags),
  accomplishments: z.string().max(500).transform(stripHtmlTags),

  mediaAvatar: createImgSchema('Avatar is required'),
  mediaCover: createImgSchema().nullable().optional(),
  mediaBanner: createImgSchema().nullable().optional(),
  mediaWelcome: MediaVideo.nullable().optional(),

  keywords: z.array(z.string()).default([]),
});

export type ProfileFormValues = z.infer<typeof profileSchema>;
